import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import PhoneNumber from '../phone_numbers/PhoneNumber.js'

export default function List({ companyId }) {
  const { isLoading, error, data } = useQuery(['phone_numbers'], () => PhoneNumber.list(), {
    placeholderData: []
  })

  return (
    <Container>
      {isLoading && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='info'>
              Loading...
            </Alert>
          </Col>
        </Row>
        )}
      {error && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='danger'>
              {error}
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <h1 className='display-6'>Phone Numbers</h1>
        </Col>
        <Col>
          <Link to={`/phone_numbers/new`} className='btn btn-primary'>
            New Phone Number
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Status</th>
                <th>Area Code</th>
                <th>Number</th>
              </tr>
            </thead>
            <tbody>
            { data.map((p) => (
              <tr key={p.id}>
                <td>
                  <Link to={`/phone_numbers/${p.id}`}>
                    {p.id}
                  </Link>
                </td>
                <td className='text-truncate'>{p.status}</td>
                <td className='text-truncate'>{p.area_code}</td>
                <td className='text-truncate'>{p.number}</td>
              </tr>
            ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  )
}